import React from "react";
import { Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DateFilterPicker = ({
    label = "Filter by Date",
    value,
    onChange,
    sx = {},
    ...props
}) => {
    return (
        <Box sx={{ flex: 1, minWidth: 160, maxWidth: 200, ...sx }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={label}
                    value={value}
                    onChange={onChange}
                    slotProps={{
                        textField: {
                            size: "small",
                            fullWidth: true,
                            sx: {
                                "& .MuiOutlinedInput-root": {
                                    height: "50px", // Set the height of the input field
                                    display: "flex",
                                    alignItems: "center", // Vertically align the content in the center
                                },
                                "& .MuiInputBase-input": {
                                    height: "50px", // Set height to match the root container
                                    padding: "0 14px", // Horizontal padding
                                    display: "flex",
                                    alignItems: "center", // Vertically center the text
                                    fontSize: "14px", // Optional: Adjust font size
                                },
                                "& .css-fd9gzh-MuiPickersInputBase-root-MuiPickersOutlinedInput-root": {
                                    height: "50px",
                                },
                                "& .css-15tkeys-MuiFormLabel-root-MuiInputLabel-root": {
                                    lineHeight: 2
                                }
                            },
                        },
                    }}
                    {...props}
                />
            </LocalizationProvider>
        </Box>
    );
};

export default DateFilterPicker;
